export function OutlineIndoorIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9801 13.0908L13.7701 14.3808L13.6401 15.1708H3.51011C3.44011 13.9408 3.36011 12.6908 3.29011 11.6508C3.27011 11.4108 3.26011 11.1708 3.25011 10.9608C3.13011 9.39076 3.48011 8.57076 3.84011 8.13076C5.18011 6.46076 8.78011 7.15076 11.3101 8.83076C12.7401 9.78076 13.8301 11.0408 13.9801 12.3808C14.0201 12.6808 14.0001 12.9408 13.9801 13.0908Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M3.25 11.6717C4.08 11.3217 5.31 10.9417 6.79 10.9617C10.79 11.0217 13.37 13.9117 13.87 14.5017"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 15.1699V8.16992"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.75 20.1708V18.0508"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M15.75 20.1708V18.0508"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M7.75 20.1708V18.0508"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M10.7998 3.13086L19.9498 6.47086L20.9498 5.21086"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6298 3L13.7498 4.29L16.3298 8.17"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 15.1699H5C3.89543 15.1699 3 16.0654 3 17.1699V18.1699C3 19.2745 3.89543 20.1699 5 20.1699H19C20.1046 20.1699 21 19.2745 21 18.1699V17.1699C21 16.0654 20.1046 15.1699 19 15.1699Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
